
import { useEffect, useState } from "react";
import { getGuidesInfiniteQuery } from "@/services/cms/queries";
import HighlightedArticle from "@/components/koach/Knowledge/components/HighlightedArticle";
import routes from "@/constants/routes";
import { Guide } from "@/services/cms/apiTypes";
import { BlogsProps } from "../types";

const BlogsMobile = ({ selectedCategory, search }: BlogsProps) => {
  const [guides, setGuides] = useState<Guide[]>([]);

  const { isLoading: isGuidesLoading, data: guidesResponse, hasNextPage, fetchNextPage } = getGuidesInfiniteQuery({ 
      populate: "category, cover",
      sort: "addedOn:desc",
      filters: {
        ...(selectedCategory !== "all" && {
          category: {
            slug: {
              $eq: selectedCategory,
            },
          },
        }),
        ...((search && search.length > 1) && {
          title: {
            $containsi: search,
          },
        }),
      },
    }
  );

  useEffect(() => {
    if (! isGuidesLoading) {
      setGuides(guidesResponse?.pages.flatMap((page) => page.data) || []);
    }
  }, [isGuidesLoading, guidesResponse]);

  return (
    <>
      <div className="md:hidden px-5 md:px-14 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
          {guides.map((guide, index) => (
            <div key={index}>
              <HighlightedArticle
                guide={guide} 
                baseUrl={routes.guides}
              />
            </div>
          ))}
        </div>

        { !isGuidesLoading && guides.length === 0 && ( 
          <div className="flex justify-center items-center p-10">
            <p className="text-lg md:text-2xl">No result found!</p>
          </div>
        )}

        {hasNextPage && (
          <div className="flex justify-center items-center font-bold mt-10 cursor-pointer" onClick={() => fetchNextPage()}>
            <span className="inline-block border border-magenta text-magenta rounded-3xl p-4">
              Show more
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default BlogsMobile;
